<template>
  <div class="kefu-container" :class="{ 'kefu-mobile-mode': mobileMode }">
    <div v-if="showTrigger" class="kefu-trigger" :class="{ active: chatOpen }" @click="toggleChat">
      <svg viewBox="0 0 1024 1024" width="24" height="24" fill="currentColor">
        <path d="M512 64C264.6 64 64 238.7 64 456c0 124.5 68.6 236.2 176 310.7V896l138.7-76.1c42.5 11.8 87.5 18.1 133.3 18.1 247.4 0 448-174.7 448-382S759.4 64 512 64z m32 544H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32z m128-160H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32z"/>
      </svg>
      <span class="kefu-label">{{ t('客服') }}</span>
      <span v-if="unreadCount > 0" class="kefu-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </div>

    <div v-if="proactiveHint && !chatOpen && !mobileMode" class="kefu-proactive-tip" @click="toggleChat">
      {{ proactiveHint }}
    </div>

    <transition name="kefu-slide">
      <div v-show="chatOpen" class="kefu-chat-window">
        <div class="kefu-header">
          <div class="kefu-header-info">
            <div class="kefu-avatar-wrap">
              <img :src="kefuInfo.avatar || '/pcImgs/logo.png'" class="kefu-avatar" />
              <span class="kefu-online-dot" :class="{ online: kefuInfo.online }"></span>
            </div>
            <div class="kefu-header-text">
              <div class="kefu-name-row">
                <div class="kefu-name">{{ kefuInfo.nickname || t('在线客服') }}</div>
                <span class="kefu-identity-chip">{{ t('官方客服') }}</span>
              </div>
              <div class="kefu-status" :class="{ online: kefuInfo.online }">
                {{ kefuInfo.online ? t('在线 · 商品、订单、售后问题都可咨询') : t('离线 · 可提交留言，我们会尽快回复') }}
              </div>
            </div>
          </div>
          <div class="kefu-header-actions">
            <div class="kefu-feedback-menu" @mouseenter="feedbackMenuOpen = true" @mouseleave="feedbackMenuOpen = false">
              <div class="kefu-feedback-trigger" :title="t('反馈与留言')">
                <svg viewBox="0 0 1024 1024" width="15" height="15" fill="currentColor">
                  <path d="M904 128H120c-22.1 0-40 17.9-40 40v536c0 22.1 17.9 40 40 40h232v164c0 10.6 12.8 15.9 20.3 8.5L540 744h364c22.1 0 40-17.9 40-40V168c0-22.1-17.9-40-40-40z m-24 552H528l-12 12-152 152V680H144V192h736v488z"/>
                </svg>
                <span>{{ t('反馈') }}</span>
                <span v-if="feedbackUnreadCount > 0" class="feedback-dot"></span>
              </div>
              <transition name="fade-drop">
                <div v-show="feedbackMenuOpen" class="kefu-feedback-dropdown">
                  <div class="fb-drop-item" @click="openFeedbackForm(); feedbackMenuOpen = false">
                    <svg viewBox="0 0 1024 1024" width="14" height="14" fill="currentColor">
                      <path d="M904 128H120c-22.1 0-40 17.9-40 40v536c0 22.1 17.9 40 40 40h232v164c0 10.6 12.8 15.9 20.3 8.5L540 744h364c22.1 0 40-17.9 40-40V168c0-22.1-17.9-40-40-40z m-24 552H528l-12 12-152 152V680H144V192h736v488z"/>
                    </svg>
                    <span>{{ t('提交留言') }}</span>
                  </div>
                  <div class="fb-drop-item" @click="openMyFeedbackList(); feedbackMenuOpen = false">
                    <svg viewBox="0 0 1024 1024" width="14" height="14" fill="currentColor">
                      <path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c-8.8 0-16-7.2-16-16s7.2-16 16-16h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H368zm0-160c-8.8 0-16-7.2-16-16s7.2-16 16-16h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H368zm0-160c-8.8 0-16-7.2-16-16s7.2-16 16-16h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H368z"/>
                    </svg>
                    <span>{{ t('我的留言') }}</span>
                    <span v-if="feedbackUnreadCount > 0" class="fb-drop-badge">{{ feedbackUnreadCount }}</span>
                  </div>
                </div>
              </transition>
            </div>
            <div class="kefu-close" @click="chatOpen = false">
              <svg viewBox="0 0 1024 1024" width="18" height="18" fill="currentColor">
                <path d="M563.8 512l262.5-312.9c4.4-5.2 0.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L512 449.8 295.9 191.7c-3-3.6-7.5-5.7-12.3-5.7H203.8c-6.8 0-10.5 7.9-6.1 13.1L460.2 512 197.7 824.9c-4.4 5.2-0.7 13.1 6.1 13.1h79.8c4.7 0 9.2-2.1 12.3-5.7L512 574.2l216.1 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"/>
              </svg>
            </div>
          </div>
        </div>

        <div ref="messageBox" class="kefu-messages" @scroll="onScroll">
          <div v-if="hasMore" class="load-more" @click="loadMore">
            <span>{{ t('加载更多历史消息') }}</span>
          </div>

          <div
            v-for="(msg, i) in messageList"
            :key="msg.id || i"
            :class="['msg-item', (msg._isSystemTip || msg.msn_type === 9) ? 'msg-system-tip' : (msg.uid === myUid ? 'msg-mine' : 'msg-other')]"
          >
            <div v-if="showTimeFor(i)" class="msg-time-divider">
              <span>{{ formatTime(msg.create_time) }}</span>
            </div>

            <div v-if="msg._isSystemTip || msg.msn_type === 9" class="msg-system-tip-text">
              {{ msg.msn }}
            </div>

            <div v-else-if="isWelcomeCardMessage(msg)" class="msg-content-wrap msg-content-wrap-welcome">
              <img :src="kefuInfo.avatar || '/pcImgs/logo.png'" class="msg-avatar" />
              <div class="msg-bubble-area welcome-bubble-area">
                <div class="welcome-card">
                  <div class="welcome-card-head">
                    <span class="welcome-card-tag">{{ t('智能助手') }}</span>
                    <span class="welcome-card-caption">{{ t('常见问题快捷咨询') }}</span>
                  </div>
                  <div class="welcome-card-text">{{ getWelcomeCardData(msg).text }}</div>
                  <button
                    v-for="(question, qIndex) in getWelcomeCardData(msg).questions"
                    :key="msg.id + '_q_' + qIndex"
                    type="button"
                    class="welcome-card-question"
                    @click="sendPresetQuestion(question)"
                  >
                    <span class="welcome-card-question-text">{{ question }}</span>
                    <span class="welcome-card-arrow">›</span>
                  </button>
                  <div class="welcome-card-footer">{{ getWelcomeCardData(msg).footer }}</div>
                </div>
              </div>
            </div>

            <div v-else class="msg-content-wrap">
              <img v-if="msg.uid !== myUid" :src="kefuInfo.avatar || '/pcImgs/logo.png'" class="msg-avatar" />
              <div class="msg-bubble-area">
                <div
                  class="msg-bubble"
                  :class="{
                    'msg-bubble-card': isGoodsMessage(msg) || isOrderCard(msg),
                    'msg-bubble-media': msg.msn_type === 2 || msg.msn_type === 4
                  }"
                >
                  <span v-if="msg.msn_type === 1" class="msg-text">{{ msg.msn }}</span>

                  <img
                    v-else-if="msg.msn_type === 2"
                    :src="getImageUrl(msg.msn)"
                    class="msg-image"
                    @click="previewImage(getImageUrl(msg.msn))"
                  />

                  <video
                    v-else-if="msg.msn_type === 4"
                    :src="getImageUrl(msg.msn)"
                    class="msg-video"
                    controls
                    preload="metadata"
                  ></video>

                  <div v-else-if="isGoodsMessage(msg)" class="goods-card" @click="goGoods(parseCard(msg.msn))">
                    <div class="goods-card-thumb-wrap">
                      <img class="goods-card-img" :src="parseCard(msg.msn).image || '/pcImgs/logo.png'" />
                    </div>
                    <div class="goods-card-info">
                      <div class="goods-card-title">{{ parseCard(msg.msn).name }}</div>
                      <div class="goods-card-meta">{{ t('商品咨询') }}</div>
                      <div class="goods-card-footer">
                        <div class="goods-card-price">￥{{ parseCard(msg.msn).price }}</div>
                        <div class="goods-card-action">{{ t('查看商品') }}</div>
                      </div>
                    </div>
                  </div>

                  <div v-else-if="isOrderCard(msg)" class="order-card-bubble" @click="goOrderDetail(parseCard(msg.msn))">
                    <div class="order-card-head">
                      <span class="order-card-label">{{ t('订单信息') }}</span>
                      <span class="order-card-status">{{ orderStatusText(parseCard(msg.msn).status) }}</span>
                    </div>
                    <div class="order-card-body">
                      <img
                        v-if="parseCard(msg.msn).goods_image"
                        class="order-card-img"
                        :src="getImageUrl(parseCard(msg.msn).goods_image)"
                      />
                      <div class="order-card-info">
                        <div class="order-card-name">{{ parseCard(msg.msn).goods_name }}</div>
                        <div class="order-card-price">￥{{ parseCard(msg.msn).pay_money }}</div>
                      </div>
                    </div>
                    <div class="order-card-foot">
                      <span class="order-card-no">{{ parseCard(msg.msn).order_no }}</span>
                      <span v-if="parseCard(msg.msn).goods_count > 1" class="order-card-count">
                        {{ t('共{count}件', { count: parseCard(msg.msn).goods_count }) }}
                      </span>
                    </div>
                    <div class="order-card-action">
                      <span class="order-card-pay-btn">
                        {{ parseCard(msg.msn).status == 0 ? t('立即支付') : t('查看订单') }}
                      </span>
                    </div>
                  </div>

                  <span v-else-if="isGoodsInquiry(msg)" class="msg-text">{{ formatGoodsInquiryText(parseCard(msg.msn).name) }}</span>
                  <span v-else class="msg-text">{{ msg.msn }}</span>
                </div>

                <span v-if="msg.sendFailed" class="msg-send-failed" @click="resendMsg(msg)">
                  {{ t('发送失败') }} · <em>{{ t('重试') }}</em>
                </span>
                <span v-else-if="msg.uid === myUid && !msg._isSystemTip && msg.msn_type !== 9" class="msg-read-status">
                  {{ msg.is_read ? t('已读') : t('未读') }}
                </span>
              </div>
              <img v-if="msg.uid === myUid" :src="myAvatar || '/pcImgs/logo.png'" class="msg-avatar" />
            </div>
          </div>
        </div>

        <div v-if="typingText" class="kefu-typing">
          <span class="typing-dots"><i></i><i></i><i></i></span>
          {{ typingText }}
        </div>

        <div class="kefu-input-area">
          <div v-if="showEmojiPanel" class="emoji-panel" @click.stop>
            <div class="emoji-tabs">
              <span
                v-for="(cat, ci) in emojiCategories"
                :key="ci"
                :class="['emoji-tab', { active: emojiTabIndex === ci }]"
                @click="emojiTabIndex = ci"
              >
                {{ cat.icon }}
              </span>
            </div>
            <div class="emoji-grid">
              <span
                v-for="(em, ei) in emojiCategories[emojiTabIndex].emojis"
                :key="ei"
                class="emoji-item"
                @click="insertEmoji(em)"
              >
                {{ em }}
              </span>
            </div>
          </div>

          <div v-if="pendingGoods" class="kefu-pending-strip">
            <img
              class="kefu-pending-image"
              :src="getImageUrl(pendingGoods.image || pendingGoods.goods_image || '') || '/pcImgs/logo.png'"
            />
            <div class="kefu-pending-info">
              <div class="kefu-pending-title">{{ pendingGoods.name || pendingGoods.goods_name || t('商品咨询') }}</div>
              <div class="kefu-pending-subtitle">{{ t('已为您准备商品信息，确认后可发送给客服') }}</div>
            </div>
            <div class="kefu-pending-actions">
              <div class="kefu-pending-price">￥{{ formatPendingGoodsPrice(pendingGoods.price) }}</div>
              <div class="kefu-pending-buttons">
                <button type="button" class="kefu-pending-cancel" @click="pendingGoods = null">{{ t('取消') }}</button>
                <button type="button" class="kefu-pending-send" @click="sendPendingGoods">{{ t('发送') }}</button>
              </div>
            </div>
          </div>

          <div class="kefu-input-shell">
            <div class="kefu-input-row">
              <input
                v-model="inputText"
                class="kefu-text-input"
                :placeholder="t('输入消息...')"
                @keyup.enter="sendText"
              />
              <button class="kefu-send-btn" :disabled="!inputText.trim()" @click="sendText">
                {{ t('发送') }}
              </button>
            </div>
            <div class="kefu-input-tools">
              <label class="kefu-tool-btn" :title="t('发送图片')">
                <svg viewBox="0 0 1024 1024" width="18" height="18" fill="currentColor">
                  <path d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32z m-40 632H136v-79.4l192.4-211.6 165.1 181.6 215.3-215.3L888 650.8V792z m0-209.8L722.2 408.6c-12.5-12.5-32.7-12.5-45.2 0L467.8 617.8l-165-181.5c-11.8-13-31.7-14-44.8-2.5L136 562.4V232h752v350.2z"/>
                  <path d="M304 456c48.6 0 88-39.4 88-88s-39.4-88-88-88-88 39.4-88 88 39.4 88 88 88z"/>
                </svg>
                <input type="file" accept="image/*" @change="handleImageUpload" style="display:none;" />
              </label>
              <label class="kefu-tool-btn" :title="t('发送视频')">
                <svg viewBox="0 0 1024 1024" width="18" height="18" fill="currentColor">
                  <path d="M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226z"/>
                </svg>
                <input type="file" accept="video/*" @change="handleVideoUpload" style="display:none;" />
              </label>
              <div class="kefu-tool-btn emoji-btn" :title="t('表情')" @click.stop="toggleEmojiPanel">
                <svg viewBox="0 0 1024 1024" width="18" height="18" fill="currentColor">
                  <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm-48-532a48 48 0 1 0-96 0 48 48 0 0 0 96 0zm208 0a48 48 0 1 0-96 0 48 48 0 0 0 96 0zm-42.4 262.4a222.3 222.3 0 0 1-115.6 34.6 222.3 222.3 0 0 1-115.6-34.6 12 12 0 1 0-14.4 19.2A246 246 0 0 0 512 672a246 246 0 0 0 129.6-39.2 12 12 0 0 0-14.4-19.2z" />
                </svg>
              </div>
              <span class="kefu-paste-hint">{{ t('支持 Ctrl+V 粘贴图片') }}</span>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <div v-show="showFeedbackForm" ref="feedbackOverlay" class="feedback-overlay" @click.self="showFeedbackForm = false">
      <div class="feedback-modal">
        <div class="feedback-header">
          <span>{{ t('留言') }}</span>
          <div class="feedback-close" @click="showFeedbackForm = false">&times;</div>
        </div>
        <div class="feedback-body">
          <div class="feedback-field">
            <label>{{ t('问题类型') }}</label>
            <div class="feedback-category-tags">
              <span
                v-for="cat in feedbackCategoryOptions"
                :key="cat.key"
                class="feedback-category-tag"
                :class="{ active: feedbackForm.category === cat.key }"
                @click="feedbackForm.category = cat.key"
              >
                {{ cat.label }}
              </span>
            </div>
          </div>
          <div class="feedback-field">
            <label>{{ t('联系人') }} <em>*</em></label>
            <input v-model="feedbackForm.rela_name" :placeholder="t('请输入联系人姓名')" maxlength="64" />
          </div>
          <div class="feedback-field">
            <label>{{ t('手机号') }} <em>*</em></label>
            <input v-model="feedbackForm.phone" :placeholder="t('请输入手机号')" maxlength="11" />
          </div>
          <div class="feedback-field">
            <label>{{ t('留言内容') }} <em>*</em></label>
            <textarea v-model="feedbackForm.content" :placeholder="t('请描述您的问题')" maxlength="500" rows="4"></textarea>
            <div class="feedback-char-count">{{ feedbackForm.content.length }}/500</div>
          </div>
          <div class="feedback-field">
            <label>{{ t('图片（最多3张）') }}</label>
            <div class="feedback-img-list">
              <div v-for="(img, idx) in feedbackForm.images" :key="idx" class="feedback-img-item">
                <img :src="img" />
                <span class="feedback-img-del" @click="feedbackForm.images.splice(idx, 1)">&times;</span>
              </div>
              <label v-if="feedbackForm.images.length < 3" class="feedback-img-add">
                <span>+</span>
                <input type="file" accept="image/*" @change="uploadFeedbackImage" style="display:none;" />
              </label>
            </div>
          </div>
        </div>
        <div class="feedback-footer">
          <button class="feedback-cancel-btn" @click="showFeedbackForm = false">{{ t('取消') }}</button>
          <button class="feedback-submit-btn" :disabled="feedbackSubmitting" @click="submitFeedbackForm">
            {{ feedbackSubmitting ? t('提交中...') : t('提交') }}
          </button>
        </div>
      </div>
    </div>

    <div v-show="showMyFeedbackList" ref="myFeedbackOverlay" class="feedback-overlay" @click.self="showMyFeedbackList = false">
      <div class="feedback-modal my-feedback-modal">
        <div class="feedback-header">
          <span>{{ t('我的留言') }}</span>
          <div class="feedback-close" @click="showMyFeedbackList = false">&times;</div>
        </div>
        <div class="my-feedback-body">
          <div v-if="myFeedbackLoading && myFeedbackItems.length === 0" class="my-feedback-loading">
            <span>{{ t('加载中...') }}</span>
          </div>
          <div v-else-if="myFeedbackItems.length === 0" class="my-feedback-empty">
            <span>{{ t('暂无留言记录') }}</span>
          </div>
          <div v-else class="my-feedback-list">
            <div
              v-for="item in myFeedbackItems"
              :key="item.id"
              class="my-feedback-card"
              @click="openFeedbackDetail(item.id)"
            >
              <div class="mf-card-top">
                <span v-if="item.category" class="mf-category">{{ formatFeedbackCategory(item.category) }}</span>
                <span class="mf-status" :class="'mf-status-' + item.status">
                  {{ feedbackStatusText(item.status) }}
                </span>
                <span v-if="item.status == 2 && item.is_read == 0" class="mf-unread-dot"></span>
              </div>
              <div class="mf-content">{{ item.content_short }}</div>
              <div v-if="item.admin_reply_short" class="mf-reply">
                <span class="mf-reply-label">{{ t('客服回复') }}:</span>{{ item.admin_reply_short }}
              </div>
              <div class="mf-time">{{ formatFeedbackTime(item.create_time) }}</div>
            </div>
            <div v-if="myFeedbackItems.length < myFeedbackTotal" class="my-feedback-load-more" @click="loadMoreFeedback">
              <span>{{ myFeedbackLoading ? t('加载中...') : t('加载更多') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="showFeedbackDetail" ref="feedbackDetailOverlay" class="feedback-overlay" @click.self="closeFeedbackDetail">
      <div class="feedback-modal my-feedback-modal">
        <div class="feedback-header">
          <span class="feedback-back" @click="closeFeedbackDetail">
            <svg viewBox="0 0 1024 1024" width="14" height="14" fill="currentColor">
              <path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9 0.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"/>
            </svg>
            {{ t('返回列表') }}
          </span>
          <div class="feedback-close" @click="closeFeedbackDetail">&times;</div>
        </div>
        <div v-if="feedbackDetailData" class="my-feedback-body feedback-detail-body">
          <div class="fd-bubble fd-bubble-user">
            <div v-if="feedbackDetailData.category" class="fd-bubble-category">{{ formatFeedbackCategory(feedbackDetailData.category) }}</div>
            <div class="fd-bubble-content">{{ feedbackDetailData.content }}</div>
            <div v-if="feedbackDetailData.images && feedbackDetailData.images.length" class="fd-bubble-images">
              <img v-for="(img, i) in feedbackDetailData.images" :key="i" :src="img" @click="previewFeedbackImage(img)" />
            </div>
            <div class="fd-bubble-meta">
              <span>{{ feedbackDetailData.rela_name }} · {{ feedbackDetailData.phone }}</span>
              <span>{{ formatFeedbackTime(feedbackDetailData.create_time) }}</span>
            </div>
          </div>
          <div v-if="feedbackDetailData.admin_reply" class="fd-bubble fd-bubble-admin">
            <div class="fd-bubble-label">{{ t('客服回复') }}</div>
            <div class="fd-bubble-content">{{ feedbackDetailData.admin_reply }}</div>
            <div class="fd-bubble-meta">
              <span>{{ formatFeedbackTime(feedbackDetailData.reply_time) }}</span>
            </div>
          </div>
          <div class="fd-status-tag" :class="'mf-status-' + feedbackDetailData.status">
            {{ feedbackStatusText(feedbackDetailData.status) }}
          </div>
          <div v-if="feedbackDetailData.status != 1" class="fd-append-bar">
            <input v-model="feedbackAppendText" :placeholder="t('追加内容...')" maxlength="500" @keyup.enter="doAppendFeedback" />
            <button :disabled="feedbackAppending || !feedbackAppendText.trim()" @click="doAppendFeedback">
              {{ feedbackAppending ? t('发送中...') : t('发送') }}
            </button>
          </div>
        </div>
        <div v-else class="my-feedback-body">
          <div class="my-feedback-loading"><span>{{ t('加载中...') }}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getKefuInfo, getKefuConfig, getChatHistory, sendMessage, markRead, getUnreadCount, getAutoReply, saveOfflineFeedback, submitFeedback, getMyFeedbackList, getFeedbackDetail, appendFeedback, markWelcomeCardShown } from '@/api/kefu';
import kefuSocket from '@/utils/kefuSocket';
import { baseURL } from '@/utils/request';

export default {
  name: 'KefuFloat',
  props: {
    showTrigger: {
      type: Boolean,
      default: true,
    },
    mobileMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      kefuConfig: null,
      showPhoneModal: false,
      showPhoneNumber: '',
      chatOpen: false,
      kefuInfo: {},
      messageList: [],
      inputText: '',
      myUid: 0,
      myAvatar: '',
      hasMore: true,
      page: 1,
      loading: false,
      unreadCount: 0,
      proactiveHint: '',
      proactiveHintTimer: null,
      initialized: false,
      realtimeReady: false,
      realtimeInitPromise: null,
      unreadSyncTimer: null,
      lastSendTime: 0,
      typingText: '',
      typingTimer: null,
      pendingGoods: null,
      notificationGranted: false,
      pollTimer: null,
      pollCount: 0,
      statusTimer: null,
      showFeedbackForm: false,
      feedbackForm: { rela_name: '', phone: '', content: '', images: [], category: 'other' },
      feedbackCategoryKeys: ['refund_issue', 'logistics_query', 'product_quality', 'after_sales_service', 'other'],
      feedbackSubmitting: false,
      showMyFeedbackList: false,
      myFeedbackItems: [],
      myFeedbackPage: 1,
      myFeedbackTotal: 0,
      myFeedbackLoading: false,
      feedbackUnreadCount: 0,
      feedbackMenuOpen: false,
      showFeedbackDetail: false,
      feedbackDetailData: null,
      feedbackAppendText: '',
      feedbackAppending: false,
      showEmojiPanel: false,
      emojiTabIndex: 0,
      emojiCategories: [
        { icon: '😀', name: '表情', emojis: ['😀','😁','😂','🤣','😃','😄','😅','😆','😉','😊','😋','😎','😍','🥰','😘','😗','😙','😚','🙂','🤗','🤩','🤔','🤨','😐','😑','😶','🙄','😏','😣','😥','😮','🤐','😯','😪','😫','😴','😌','😛','😜','😝','🤤','😒','😓','😔','😕','🙃','🤑','😲','🙁','😖','😞','😟','😤','😢','😭','😦','😧','😨','😩','🤯','😬','😰','😱','🥵','🥶','😳','🤪','😵','😡','😠','🤬','😷','🤒','🤕','🤢','🤮','🥴','😇','🥳','🥺','🤠','🤡','🤥','🤫','🤭','🧐','🤓'] },
        { icon: '👍', name: '手势', emojis: ['👍','👎','👌','✌️','🤞','🤟','🤘','🤙','👋','🤚','🖐️','✋','👏','🙌','👐','🤲','🤝','🙏','✍️','💪','☝️','👆','👇','👈','👉'] },
        { icon: '❤️', name: '爱心', emojis: ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖','💘','💝','💟'] },
        { icon: '🎉', name: '日常', emojis: ['🎉','🎊','🎈','🎁','🎀','🏆','🥇','⭐','🌟','✨','🔥','💯','👑','💰','💵','🛒','📦','🚗','✈️','🏠','📱','💻','⌚','📷','🔔','📢'] },
        { icon: '🍎', name: '食物', emojis: ['🍎','🍊','🍋','🍇','🍓','🍑','🍒','🥝','🍌','🍉','🍔','🍕','🍗','🍜','🍣','🍦','🍰','🎂','🍩','☕','🍺','🥤','🧋'] },
        { icon: '🌸', name: '自然', emojis: ['🌸','🌺','🌻','🌹','🌷','🌼','🍀','🌈','☀️','🌙','⭐','🌊','🐶','🐱','🐼','🐻','🦊','🐰','🐸','🐵','🦁','🐮','🐷'] },
      ],
    };
  },
  computed: {
    feedbackCategoryOptions() {
      return this.feedbackCategoryKeys.map(key => ({
        key,
        label: this.t(`feedback_category.${key}`),
        backendValue: this.feedbackCategoryBackendValue(key),
      }));
    },
  },
  watch: {
    chatOpen(val) {
      this.$emit('chat-state-change', val);
      if (val) {
        this.handleChatOpened();
      } else {
        this.stopPollMessages();
        this.stopStatusRefresh();
        this.startUnreadSync();
      }
    },
    unreadCount: {
      handler(val) {
        this.$emit('badge-change', val);
      },
      immediate: true,
    },
  },
  mounted() {
    const userinfo = JSON.parse(window.localStorage.getItem('userinfo') || '{}');
    this.myUid = userinfo.id || 0;
    this.myAvatar = this.getImageUrl(userinfo.avatar || '');
    // 加载客服配置
    this.loadKefuConfig();
    // 请求浏览器通知权限
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission().then(p => { this.notificationGranted = p === 'granted'; });
    } else {
      this.notificationGranted = Notification.permission === 'granted';
    }
    // 监听商品咨询事件（从商品详情页触发）
    window.addEventListener('kefu-consult-goods', this.onConsultGoods);
    // 监听粘贴事件（Ctrl+V 图片）
    document.addEventListener('paste', this.handlePaste);
    document.addEventListener('click', this.closeEmojiPanel);
    // 将留言弹窗移到 body，避免 .float-sidebar 的 transform 影响 position:fixed
    this.$nextTick(() => {
      if (this.$refs.feedbackOverlay) {
        document.body.appendChild(this.$refs.feedbackOverlay);
      }
      if (this.$refs.myFeedbackOverlay) {
        document.body.appendChild(this.$refs.myFeedbackOverlay);
      }
      if (this.$refs.feedbackDetailOverlay) {
        document.body.appendChild(this.$refs.feedbackDetailOverlay);
      }
    });
    // 定时检查留言未读数
    this.checkFeedbackUnread();
    this.feedbackUnreadTimer = setInterval(() => this.checkFeedbackUnread(), 60000);
    if (this.getStoredToken()) {
      this.initializeRealtime();
    }
  },
  beforeDestroy() {
    kefuSocket.close();
    this.stopPollMessages();
    this.stopStatusRefresh();
    this.stopUnreadSync();
    if (this.proactiveHintTimer) { clearTimeout(this.proactiveHintTimer); this.proactiveHintTimer = null; }
    window.removeEventListener('kefu-consult-goods', this.onConsultGoods);
    document.removeEventListener('paste', this.handlePaste);
    document.removeEventListener('click', this.closeEmojiPanel);
    this.closePhoneModal();
    // 清理 portal 到 body 的留言弹窗
    if (this.$refs.feedbackOverlay && this.$refs.feedbackOverlay.parentNode) {
      this.$refs.feedbackOverlay.parentNode.removeChild(this.$refs.feedbackOverlay);
    }
    if (this.$refs.myFeedbackOverlay && this.$refs.myFeedbackOverlay.parentNode) {
      this.$refs.myFeedbackOverlay.parentNode.removeChild(this.$refs.myFeedbackOverlay);
    }
    if (this.$refs.feedbackDetailOverlay && this.$refs.feedbackDetailOverlay.parentNode) {
      this.$refs.feedbackDetailOverlay.parentNode.removeChild(this.$refs.feedbackDetailOverlay);
    }
    if (this.feedbackUnreadTimer) { clearInterval(this.feedbackUnreadTimer); }
  },
  methods: {
    t(key, params) {
      if (this.$t) return this.$t(key, params);
      return key;
    },
    feedbackCategoryBackendValue(key) {
      const map = {
        refund_issue: '退款问题',
        logistics_query: '物流查询',
        product_quality: '商品质量',
        after_sales_service: '售后服务',
        other: '其他',
      };
      return map[key] || map.other;
    },
    feedbackCategoryKeyFromValue(value) {
      const normalized = String(value || '').trim();
      const match = this.feedbackCategoryOptions.find(option =>
        option.key === normalized || option.backendValue === normalized || option.label === normalized
      );
      return match ? match.key : 'other';
    },
    formatFeedbackCategory(value) {
      return this.t(`feedback_category.${this.feedbackCategoryKeyFromValue(value)}`);
    },
    feedbackStatusText(status) {
      const map = {
        0: this.t('待处理'),
        1: this.t('已完结'),
        2: this.t('已回复'),
      };
      return map[status] || '';
    },
    formatGoodsInquiryText(name) {
      return this.t('咨询商品：{name}', { name: name || '' });
    },
    async openFromExternal() {
      if (this.chatOpen) {
        return;
      }
      await this.toggleChat();
      if (!this.chatOpen) return;
    },
    async handleChatOpened() {
      this.stopUnreadSync();
      this.unreadCount = 0;
      this.proactiveHint = '';

      await this.initializeRealtime();
      if (!this.chatOpen) return;

      if (!this.initialized) {
        await this.loadHistory();
        this.initialized = true;
      } else if (!this.kefuInfo.uid) {
        await this.fetchKefuInfo();
      }

      if (!this.chatOpen) return;

      await this.handleChatOpenFlow();
      this.startPollMessages();
      this.startStatusRefresh();
      this.$nextTick(() => this.scrollToBottom());
    },
    copyPhone() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.showPhoneNumber).then(() => {
          this.$message && this.$message.success(this.t('已复制到剪贴板'));
        });
      } else {
        const input = document.createElement('input');
        input.value = this.showPhoneNumber;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$message && this.$message.success(this.t('已复制到剪贴板'));
      }
    },
    openPhoneModal(phone) {
      this.showPhoneNumber = phone;
      this.closePhoneModal();
      const overlay = document.createElement('div');
      Object.assign(overlay.style, {
        position: 'fixed', top: '0', left: '0', right: '0', bottom: '0',
        background: 'rgba(0,0,0,0.4)', zIndex: '10001',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      });
      overlay.addEventListener('click', (e) => { if (e.target === overlay) this.closePhoneModal(); });
      overlay.innerHTML = `
        <div style="background:#fff;border-radius:12px;padding:28px 32px;min-width:320px;box-shadow:0 12px 40px rgba(0,0,0,0.15);text-align:center;">
          <div style="display:flex;justify-content:space-between;align-items:center;font-size:16px;font-weight:600;color:#333;margin-bottom:20px;">
            <span>${this.t('客服电话')}</span>
            <span id="kefu-phone-close-btn" style="cursor:pointer;font-size:22px;color:#999;line-height:1;">&times;</span>
          </div>
          <div style="font-size:28px;font-weight:700;color:#07c160;letter-spacing:2px;margin-bottom:24px;">${phone}</div>
          <div style="display:flex;gap:12px;justify-content:center;">
            <button id="kefu-phone-copy-btn" style="padding:10px 24px;border-radius:8px;font-size:14px;cursor:pointer;background:#f5f5f5;color:#333;border:none;">${this.t('复制号码')}</button>
            <a href="tel:${phone}" style="padding:10px 24px;border-radius:8px;font-size:14px;cursor:pointer;background:#07c160;color:#fff;text-decoration:none;">${this.t('拨打电话')}</a>
          </div>
        </div>`;
      document.body.appendChild(overlay);
      this._phoneOverlay = overlay;
      overlay.querySelector('#kefu-phone-close-btn').addEventListener('click', () => this.closePhoneModal());
      overlay.querySelector('#kefu-phone-copy-btn').addEventListener('click', () => this.copyPhone());
    },
    closePhoneModal() {
      if (this._phoneOverlay) {
        this._phoneOverlay.remove();
        this._phoneOverlay = null;
      }
    },
    toggleEmojiPanel() {
      this.showEmojiPanel = !this.showEmojiPanel;
    },
    insertEmoji(emoji) {
      this.inputText += emoji;
    },
    closeEmojiPanel() {
      this.showEmojiPanel = false;
    },
    getStoredToken() {
      return window.localStorage.getItem('token') || '';
    },
    async fetchKefuInfo() {
      try {
        const { data } = await getKefuInfo('pc');
        if (data.code === 1 && data.data) {
          this.kefuInfo = {
            ...this.kefuInfo,
            ...data.data,
          };
          if (this.kefuInfo.avatar) this.kefuInfo.avatar = this.getImageUrl(this.kefuInfo.avatar);
        }
      } catch (e) {
        // silent
      }
      return this.kefuInfo;
    },
    async syncUnreadCount() {
      if (this.chatOpen || !this.getStoredToken()) return this.unreadCount;
      try {
        const { data } = await getUnreadCount('pc');
        if (data.code === 1 && data.data) {
          this.unreadCount = Number(data.data.count) || 0;
        }
      } catch (e) {
        // silent
      }
      return this.unreadCount;
    },
    startUnreadSync() {
      if (!this.getStoredToken()) return;
      if (!this.chatOpen) {
        this.syncUnreadCount();
      }
      if (this.unreadSyncTimer) return;
      this.unreadSyncTimer = setInterval(() => {
        if (!this.chatOpen) {
          this.syncUnreadCount();
        }
      }, 15000);
    },
    stopUnreadSync() {
      if (this.unreadSyncTimer) {
        clearInterval(this.unreadSyncTimer);
        this.unreadSyncTimer = null;
      }
    },
    startStatusRefresh() {
      if (this.statusTimer || !this.kefuInfo.uid) return;
      this.statusTimer = setInterval(async () => {
        try {
          const { data: kRes } = await getKefuInfo('pc');
          if (kRes.code === 1 && kRes.data) {
            this.kefuInfo.online = kRes.data.online;
          }
        } catch (e) { /* ignore */ }
      }, 15000);
    },
    stopStatusRefresh() {
      if (this.statusTimer) {
        clearInterval(this.statusTimer);
        this.statusTimer = null;
      }
    },
    bindSocketListeners() {
      kefuSocket.off('new_message', this._onNewMessage);
      kefuSocket.off('auth_result', this._onAuthResult);
      kefuSocket.off('typing', this._onTyping);
      kefuSocket.off('read_ack', this._onReadAck);

      this._onNewMessage = (msg) => {
        if (msg.source && msg.source !== 'pc') return;
        if (msg.id && this.messageList.some(m => m.id === msg.id)) return;

        const shouldAppendMessage = this.initialized || this.chatOpen;
        const localIdx = this.findReplaceableMessageIndex(msg);

        if (msg.uid === this.kefuInfo.uid) {
          this.kefuInfo.online = true;
        }

        if (localIdx !== -1) {
          this.$set(this.messageList, localIdx, msg);
        } else if (shouldAppendMessage) {
          this.messageList.push(msg);
        }

        if (msg.self_sync) {
          if (this.chatOpen && shouldAppendMessage) {
            this.$nextTick(() => this.scrollToBottom());
          }
          return;
        }

        if (this.chatOpen) {
          if (shouldAppendMessage) {
            this.$nextTick(() => this.scrollToBottom());
          }
          if (this.kefuInfo.uid) {
            markRead(this.kefuInfo.uid).catch(() => {});
          }
          return;
        }

        this.unreadCount += 1;
        this.showDesktopNotification(msg);
        this.showProactiveHint(msg);
      };

      this._onAuthResult = (data) => {
        if (data.code !== 1) {
          console.warn('kefu ws auth failed', data.msg);
        }
      };

      this._onTyping = () => {
        this.typingText = this.t('对方正在输入...');
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => { this.typingText = ''; }, 3000);
      };

      this._onReadAck = (data) => {
        if (data.uid && this.kefuInfo.uid) {
          this.messageList.forEach(m => {
            if (m.uid !== this.kefuInfo.uid && m.is_read === 0) {
              m.is_read = 1;
            }
          });
        }
        if (data.self_sync && this.chatOpen) {
          this.unreadCount = 0;
        }
      };

      kefuSocket.on('new_message', this._onNewMessage);
      kefuSocket.on('auth_result', this._onAuthResult);
      kefuSocket.on('typing', this._onTyping);
      kefuSocket.on('read_ack', this._onReadAck);
    },
    async initializeRealtime() {
      if (this.realtimeReady) return true;
      if (this.realtimeInitPromise) return this.realtimeInitPromise;

      const token = this.getStoredToken();
      if (!token) return false;

      this.realtimeInitPromise = (async () => {
        await this.fetchKefuInfo();
        await this.syncUnreadCount();
        this.bindSocketListeners();
        kefuSocket.connect(token);
        this.startUnreadSync();
        this.realtimeReady = true;
        return true;
      })().finally(() => {
        this.realtimeInitPromise = null;
      });

      return this.realtimeInitPromise;
    },
    async loadKefuConfig() {
      if (this.kefuConfig) return;
      try {
        const { data } = await getKefuConfig();
        if (data.code === 1 && data.data) {
          this.kefuConfig = data.data;
        }
      } catch (e) {
        // 加载失败，默认走系统客服
      }
    },
    async toggleChat() {
      const result = await this.resolveKefuEntry();
      if (result === 'system') {
        this.chatOpen = !this.chatOpen;
      }
    },
    async resolveKefuEntry() {
      const token = window.localStorage.getItem('token');
      if (!token) {
        this.$message && this.$message.warning(this.t('请先登录'));
        return null;
      }

      await this.loadKefuConfig();

      const type = this.kefuConfig?.effective_service_type || this.kefuConfig?.kefu_service_type || 'system';
      if (type === 'wechat') {
        const link = this.kefuConfig?.kefu_wechat_url;
        if (link) {
          window.open(link, '_blank', 'noopener,noreferrer');
        } else {
          this.$message && this.$message.warning(this.t('微信客服未配置'));
        }
        return 'wechat';
      }
      if (type === 'phone') {
        const phone = this.kefuConfig?.kefu_service_phone;
        if (phone) {
          this.openPhoneModal(phone);
        } else {
          this.$message && this.$message.warning(this.t('客服电话未配置'));
        }
        return 'phone';
      }
      if (type === 'link') {
        const link = this.kefuConfig?.kefu_service_link;
        if (link) {
          window.open(link, '_blank', 'noopener,noreferrer');
        } else {
          this.$message && this.$message.warning(this.t('客服链接未配置'));
        }
        return 'link';
      }
      return 'system';
    },
    async initChat() {
      await this.initializeRealtime();
      if (!this.kefuInfo.uid) {
        await this.fetchKefuInfo();
      }
      await this.loadHistory();
      this.initialized = true;
      await this.handleChatOpenFlow();
      return true;
    },
    async loadHistory() {
      if (this.loading || !this.hasMore) return;
      this.loading = true;
      try {
        const uid = this.kefuInfo.uid;
        if (!uid) return;
        const { data } = await getChatHistory(uid, this.page, 20);
        if (data.code === 1) {
          const list = data.data?.list || [];
          if (list.length < 20) this.hasMore = false;
          this.messageList = [...list.reverse(), ...this.messageList];
          this.page++;
          if (this.page === 2) {
            this.$nextTick(() => this.scrollToBottom());
          }
        }
      } catch (e) {
        // silent
      } finally {
        this.loading = false;
      }
    },
    loadMore() {
      this.loadHistory();
    },
    sendText() {
      const text = this.inputText.trim();
      if (!text) return;
      this.showEmojiPanel = false;
      const now = Date.now();
      if (now - this.lastSendTime < 2000) {
        // 在聊天窗口中显示频率限制提示
        const tipExists = this.messageList.some(m => m._rateLimitTip && now - m._rateLimitTime < 3000);
        if (!tipExists) {
          this.messageList.push({
            id: 'tip_' + now,
            msn: this.t('发送过于频繁，请稍后再试'),
            msn_type: 1,
            _isSystemTip: true,
            _rateLimitTip: true,
            _rateLimitTime: now,
            create_time: Math.floor(now / 1000),
          });
          this.$nextTick(() => this.scrollToBottom());
        }
        return;
      }
      this.lastSendTime = now;

      this.inputText = '';
      const localMsg = {
        id: 'local_' + now,
        uid: this.myUid,
        to_uid: this.kefuInfo.uid,
        msn: text,
        msn_type: 1,
        create_time: Math.floor(now / 1000),
      };
      this.messageList.push(localMsg);
      this.$nextTick(() => this.scrollToBottom());

      const sent = kefuSocket.send('chat', {
        to_uid: this.kefuInfo.uid,
        msn: text,
        msn_type: 1,
        source: 'pc',
      });
      if (!sent) {
        sendMessage(this.kefuInfo.uid, text, 1).then(res => {
          if (res.data?.code !== 1) {
            localMsg.sendFailed = true;
            this.$message && this.$message.error(res.data?.msg || this.t('发送失败'));
          }
        }).catch(() => {
          localMsg.sendFailed = true;
          this.$message && this.$message.error(this.t('发送失败，请检查网络'));
        });
      }
      // 延迟500ms确保用户消息先入库，避免自动回复排序在前
      setTimeout(() => {
        this.tryAutoReply(text);
      }, 500);
    },
    sendPresetQuestion(question) {
      this.inputText = String(question || '').trim();
      this.sendText();
    },
    resendMsg(msg) {
      msg.sendFailed = false;
      this.$forceUpdate();
      sendMessage(this.kefuInfo.uid, msg.msn, msg.msn_type).then(res => {
        if (res.data?.code !== 1) {
          msg.sendFailed = true;
          this.$forceUpdate();
          this.$message && this.$message.error(res.data?.msg || this.t('发送失败'));
        }
      }).catch(() => {
        msg.sendFailed = true;
        this.$forceUpdate();
        this.$message && this.$message.error(this.t('发送失败，请检查网络'));
      });
    },
    handleImageUpload(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.uploadImageFile(file);
      e.target.value = '';
    },
    handlePaste(e) {
      if (!this.chatOpen) return;
      const items = e.clipboardData && e.clipboardData.items;
      if (!items) return;
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          e.preventDefault();
          const file = items[i].getAsFile();
          if (!file) return;
          this.uploadImageFile(file);
          return;
        }
      }
    },
    uploadImageFile(file) {
      const formData = new FormData();
      formData.append('file', file);
      const token = window.localStorage.getItem('token') || '';
      fetch((baseURL || '') + '/api/ajax/upload', {
        method: 'POST',
        headers: { 'ba-user-token': token },
        body: formData,
      })
        .then(r => r.json())
        .then(data => {
          if (data.code === 1 && data.data?.file?.url) {
            const imgUrl = data.data.file.url;
            this.messageList.push({
              id: 'local_img_' + Date.now(),
              uid: this.myUid,
              to_uid: this.kefuInfo.uid,
              msn: imgUrl,
              msn_type: 2,
              create_time: Math.floor(Date.now() / 1000),
            });
            this.$nextTick(() => this.scrollToBottom());
            kefuSocket.send('chat', { to_uid: this.kefuInfo.uid, msn: imgUrl, msn_type: 2, source: 'pc' });
          } else {
            this.$message && this.$message.error(data.msg || this.t('图片上传失败'));
          }
        })
        .catch(() => {
          this.$message && this.$message.error(this.t('图片上传失败'));
        });
    },
    handleVideoUpload(e) {
      const file = e.target.files[0];
      if (!file) return;
      e.target.value = '';
      const formData = new FormData();
      formData.append('file', file);
      const token = window.localStorage.getItem('token') || '';
      fetch((baseURL || '') + '/api/ajax/upload', {
        method: 'POST',
        headers: { 'ba-user-token': token },
        body: formData,
      })
        .then(r => r.json())
        .then(data => {
          if (data.code === 1 && data.data?.file?.url) {
            const videoUrl = data.data.file.url;
            this.messageList.push({
              id: 'local_video_' + Date.now(),
              uid: this.myUid,
              to_uid: this.kefuInfo.uid,
              msn: videoUrl,
              msn_type: 4,
              create_time: Math.floor(Date.now() / 1000),
            });
            this.$nextTick(() => this.scrollToBottom());
            kefuSocket.send('chat', { to_uid: this.kefuInfo.uid, msn: videoUrl, msn_type: 4, source: 'pc' });
          } else {
            this.$message && this.$message.error(data.msg || this.t('视频上传失败'));
          }
        })
        .catch(() => {
          this.$message && this.$message.error(this.t('视频上传失败'));
        });
    },
    previewImage(url) {
      window.open(url, '_blank');
    },
    openFeedbackForm() {
      const userinfo = JSON.parse(window.localStorage.getItem('userinfo') || '{}');
      this.feedbackForm = {
        rela_name: userinfo.nickname || '',
        phone: userinfo.mobile || '',
        content: '',
        images: [],
        category: 'other',
      };
      this.showFeedbackForm = true;
    },
    uploadFeedbackImage(e) {
      const file = e.target.files[0];
      if (!file) return;
      e.target.value = '';
      const formData = new FormData();
      formData.append('file', file);
      const token = window.localStorage.getItem('token') || '';
      fetch((baseURL || '') + '/api/ajax/upload', {
        method: 'POST',
        headers: { 'ba-user-token': token },
        body: formData,
      })
        .then(r => r.json())
        .then(data => {
          if (data.code === 1 && data.data?.file?.url) {
            this.feedbackForm.images.push(data.data.file.url);
          } else {
            this.$message && this.$message.error(data.msg || this.t('图片上传失败'));
          }
        })
        .catch(() => {
          this.$message && this.$message.error(this.t('图片上传失败'));
        });
    },
    submitFeedbackForm() {
      const { rela_name, phone, content, category } = this.feedbackForm;
      if (!rela_name.trim()) { this.$message && this.$message.warning(this.t('请输入联系人姓名')); return; }
      if (!/^1\d{10}$/.test(phone)) { this.$message && this.$message.warning(this.t('请输入正确的手机号')); return; }
      if (!content.trim()) { this.$message && this.$message.warning(this.t('请输入留言内容')); return; }
      this.feedbackSubmitting = true;
      submitFeedback({
        rela_name: rela_name.trim(),
        phone: phone,
        content: content.trim(),
        images: this.feedbackForm.images,
        category: this.feedbackCategoryBackendValue(category || 'other'),
      }).then(res => {
        if (res.data && res.data.code === 1) {
          this.$message && this.$message.success(this.t('留言提交成功，我们会尽快回复'));
          this.showFeedbackForm = false;
          this.feedbackForm = { rela_name: '', phone: '', content: '', images: [], category: 'other' };
        } else {
          this.$message && this.$message.error((res.data && res.data.msg) || this.t('提交失败'));
        }
      }).catch(() => {
        this.$message && this.$message.error(this.t('提交失败，请稍后再试'));
      }).finally(() => {
        this.feedbackSubmitting = false;
      });
    },
    // ===== 我的留言列表 =====
    async checkFeedbackUnread() {
      try {
        const res = await getMyFeedbackList(1, 1);
        if (res.data && res.data.code === 1) {
          const newCount = res.data.data?.unread_count || 0;
          // 未读数增加时弹出浏览器通知
          if (newCount > this.feedbackUnreadCount && this.feedbackUnreadCount >= 0) {
            this.showFeedbackNotification(newCount);
          }
          this.feedbackUnreadCount = newCount;
        }
      } catch (e) { /* silent */ }
    },
    showFeedbackNotification(count) {
      if ('Notification' in window && Notification.permission === 'granted') {
        const n = new Notification(this.t('留言有新回复'), {
          body: this.t('您有 {count} 条留言收到了客服回复', { count }),
          icon: '/pcImgs/logo.png',
          tag: 'feedback-reply',
        });
        n.onclick = () => { n.close(); this.openMyFeedbackList(); };
      }
    },
    openMyFeedbackList() {
      this.showMyFeedbackList = true;
      this.myFeedbackPage = 1;
      this.myFeedbackItems = [];
      this.loadMyFeedbackList();
    },
    async loadMyFeedbackList() {
      this.myFeedbackLoading = true;
      try {
        const res = await getMyFeedbackList(this.myFeedbackPage, 10);
        if (res.data && res.data.code === 1) {
          const list = res.data.data?.list || [];
          if (this.myFeedbackPage === 1) {
            this.myFeedbackItems = list;
          } else {
            this.myFeedbackItems = this.myFeedbackItems.concat(list);
          }
          this.myFeedbackTotal = res.data.data?.total || 0;
          this.feedbackUnreadCount = res.data.data?.unread_count || 0;
        }
      } catch (e) {
        this.$message && this.$message.error(this.t('加载失败'));
      } finally {
        this.myFeedbackLoading = false;
      }
    },
    loadMoreFeedback() {
      if (this.myFeedbackLoading) return;
      this.myFeedbackPage++;
      this.loadMyFeedbackList();
    },
    async openFeedbackDetail(id) {
      this.showFeedbackDetail = true;
      this.feedbackDetailData = null;
      this.feedbackAppendText = '';
      try {
        const res = await getFeedbackDetail(id);
        if (res.data && res.data.code === 1) {
          this.feedbackDetailData = res.data.data || null;
          // 刷新列表中的已读状态
          const item = this.myFeedbackItems.find(i => i.id === id);
          if (item) item.is_read = 1;
          this.checkFeedbackUnread();
        }
      } catch (e) {
        this.$message && this.$message.error(this.t('加载详情失败'));
      }
    },
    closeFeedbackDetail() {
      this.showFeedbackDetail = false;
      this.feedbackDetailData = null;
    },
    async doAppendFeedback() {
      if (!this.feedbackAppendText.trim() || this.feedbackAppending) return;
      this.feedbackAppending = true;
      try {
        const res = await appendFeedback({ id: this.feedbackDetailData.id, content: this.feedbackAppendText.trim(), images: [] });
        if (res.data && res.data.code === 1) {
          this.$message && this.$message.success(this.t('追加成功'));
          this.feedbackAppendText = '';
          this.openFeedbackDetail(this.feedbackDetailData.id);
        } else {
          this.$message && this.$message.error((res.data && res.data.msg) || this.t('追加失败'));
        }
      } catch (e) {
        this.$message && this.$message.error(this.t('追加失败'));
      } finally {
        this.feedbackAppending = false;
      }
    },
    previewFeedbackImage(url) {
      window.open(url, '_blank');
    },
    formatFeedbackTime(ts) {
      if (!ts) return '';
      const d = new Date(ts * 1000);
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    scrollToBottom() {
      const box = this.$refs.messageBox;
      if (box) box.scrollTop = box.scrollHeight;
    },
    isTemporaryMessageId(id) {
      return /^(local_|auto_|feedback_)/.test(String(id || ''));
    },
    findReplaceableMessageIndex(targetMsg) {
      return this.messageList.findIndex((message) => {
        if (!this.isTemporaryMessageId(message.id)) return false;
        if (message.uid !== targetMsg.uid) return false;
        if (message.msn !== targetMsg.msn) return false;
        if (message.msn_type !== targetMsg.msn_type) return false;
        const messageTime = Number(message.create_time || 0);
        const targetTime = Number(targetMsg.create_time || 0);
        if (!messageTime || !targetTime) return true;
        return Math.abs(messageTime - targetTime) <= 10;
      });
    },
    onScroll() {
      const box = this.$refs.messageBox;
      if (box && box.scrollTop === 0 && this.hasMore) {
        this.loadMore();
      }
    },
    showTimeFor(index) {
      if (index === 0) return true;
      const prev = this.messageList[index - 1];
      const curr = this.messageList[index];
      return (curr.create_time - prev.create_time) > 300;
    },
    normalizeWelcomeCard(rawCard) {
      if (!rawCard || typeof rawCard !== 'object') return null;
      const text = String(rawCard.text || '').trim();
      const footer = String(rawCard.footer || this.t('此消息由机器人发送')).trim() || this.t('此消息由机器人发送');
      const questions = Array.isArray(rawCard.questions)
        ? rawCard.questions.map(item => String(item || '').trim()).filter(Boolean).slice(0, 3)
        : [];
      if (!text || !questions.length) return null;
      return { text, footer, questions };
    },
    parseWelcomeCardMessage(msg) {
      if (!msg || Number(msg.msn_type) !== 8) return null;
      try {
        const payload = typeof msg.msn === 'string' ? JSON.parse(msg.msn) : msg.msn;
        if (!payload || payload.type !== 'welcome_card') return null;
        return this.normalizeWelcomeCard(payload);
      } catch (e) {
        return null;
      }
    },
    isWelcomeCardMessage(msg) {
      return !!this.parseWelcomeCardMessage(msg);
    },
    getWelcomeCardData(msg) {
      return this.parseWelcomeCardMessage(msg) || { text: '', footer: '', questions: [] };
    },
    async ensureWelcomeCardMessage() {
      const welcomeCard = this.normalizeWelcomeCard(this.kefuInfo && this.kefuInfo.welcome_card);
      if (!welcomeCard || !this.kefuInfo.uid) return false;
      try {
        const { data } = await markWelcomeCardShown({ source: 'pc', kefu_uid: this.kefuInfo.uid });
        if (data && data.code === 1 && data.data) {
          this.kefuInfo = {
            ...this.kefuInfo,
            welcome_card_state: data.data.welcome_card_state || this.kefuInfo.welcome_card_state,
          };
          if (data.data.inserted && data.data.message) {
            this.messageList.push(data.data.message);
            this.$nextTick(() => this.scrollToBottom());
            return true;
          }
        }
      } catch (e) {
        // silent
      }
      return false;
    },
    decodeHtmlEntities(value) {
      return String(value || '')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&');
    },
    pickGoodsCardField(values) {
      for (const value of values) {
        const text = value === null || value === undefined ? '' : String(value).trim();
        if (text) return text;
      }
      return '';
    },
    normalizeGoodsCardPayload(goods) {
      if (!goods || goods.type === 'order') return null;
      const id = this.pickGoodsCardField([goods.id]);
      const name = this.pickGoodsCardField([goods.name, goods.store_name, goods.goods_name]);
      if (!id || id === '0' || !name) return null;
      const normalized = {
        id,
        name,
        image: this.pickGoodsCardField([goods.image, goods.goods_image]),
        price: this.pickGoodsCardField([goods.price]) || '0',
      };
      if (goods.stock !== undefined && goods.stock !== null && String(goods.stock).trim() !== '') normalized.stock = goods.stock;
      if (goods.sales !== undefined && goods.sales !== null && String(goods.sales).trim() !== '') normalized.sales = goods.sales;
      return normalized;
    },
    isGoodsCardPayload(data) {
      return !!this.normalizeGoodsCardPayload(data);
    },
    isGoodsMessage(msg) {
      if (!msg || this.isOrderCard(msg)) return false;
      const type = Number(msg && msg.msn_type);
      if (type === 7) return true;
      if (type !== 3 && type !== 5) return false;
      return this.isGoodsCardPayload(this.parseCard(msg.msn));
    },
    isGoodsInquiry(msg) {
      if (Number(msg && msg.msn_type) !== 3) return false;
      if (this.isOrderCard(msg) || this.isGoodsMessage(msg)) return false;
      const card = this.parseCard(msg.msn);
      return !!(card && card.name);
    },
    isOrderCard(msg) {
      if (Number(msg && msg.msn_type) !== 3) return false;
      try { const d = JSON.parse(msg.msn); return !!(d && d.type === 'order'); } catch { return false; }
    },
    orderStatusText(status) {
      const map = { 0: '待支付', 1: '拼团中', 2: '待发货', 3: '待收货', 4: '已完成', 5: '退货/售后', 6: '已取消' };
      return this.t(map[status] || '');
    },
    goOrderDetail(card) {
      if (card && card.order_id) {
        this.chatOpen = false;
        this.$router.push({ path: '/OrderInfo', query: { order_id: card.order_id } });
      } else if (card && card.order_no) {
        this.chatOpen = false;
        this.$router.push({ path: '/Orders' });
      }
    },
    formatTime(ts) {
      const d = new Date(ts * 1000);
      const pad = n => String(n).padStart(2, '0');
      const today = new Date();
      if (d.toDateString() === today.toDateString()) {
        return pad(d.getHours()) + ':' + pad(d.getMinutes());
      }
      return (d.getMonth() + 1) + '/' + d.getDate() + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    },
    parseCard(msn) {
      let card = { id: 0, name: '', image: '', price: '0', goods_image: '', goods_name: '', stock: '', sales: '' };
      try {
        card = JSON.parse(msn);
      } catch (e) {
        try {
          card = JSON.parse(this.decodeHtmlEntities(msn));
        } catch (err) {
          return card;
        }
      }
      if (card.type === 'order') {
        if (card.goods_image) card.goods_image = this.getImageUrl(card.goods_image);
        return card;
      }
      const normalized = this.normalizeGoodsCardPayload(card);
      if (normalized) {
        const image = normalized.image ? this.getImageUrl(normalized.image) : '';
        return {
          ...card,
          ...normalized,
          image,
          goods_image: image,
          goods_name: normalized.name,
        };
      }
      if (!card.image && card.goods_image) card.image = card.goods_image;
      if (card.image) card.image = this.getImageUrl(card.image);
      if (card.goods_image) card.goods_image = this.getImageUrl(card.goods_image);
      if (!card.name && card.store_name) card.name = card.store_name;
      if (!card.name && card.goods_name) card.name = card.goods_name;
      return card;
    },
    formatPendingGoodsPrice(price) {
      const amount = Number(price);
      if (Number.isFinite(amount)) return amount.toFixed(2);
      const text = String(price || '').trim();
      return text || '0.00';
    },
    goGoods(card) {
      if (card && card.id) {
        this.$router.push({ path: '/goods', query: { id: card.id } });
      }
    },
    async handleChatOpenFlow() {
      await this.ensureWelcomeCardMessage();
      if (this.kefuInfo.uid) {
        try {
          await markRead(this.kefuInfo.uid);
        } catch (e) {
          // silent
        }
      }
      this.$nextTick(() => this.scrollToBottom());
      return true;
    },
    onConsultGoods(e) {
      const goods = this.normalizeGoodsCardPayload(e && e.detail);
      if (!goods) return;
      this.pendingGoods = goods;
      const token = window.localStorage.getItem('token');
      if (!token) {
        this.$message && this.$message.warning(this.t('请先登录'));
        return;
      }
      if (this.chatOpen && this.initialized) {
        this.handleChatOpenFlow();
        return;
      }
      this.openFromExternal();
    },
    async sendGoodsCard(goods, options = {}) {
      const normalizedGoods = this.normalizeGoodsCardPayload(goods);
      if (!normalizedGoods || !this.kefuInfo.uid) return false;
      const msn = JSON.stringify(normalizedGoods);
      const payload = { to_uid: this.kefuInfo.uid, msn, msn_type: 3, source: 'pc' };
      const sent = kefuSocket.send('chat', payload);
      if (!sent) {
        try {
          const res = await sendMessage(this.kefuInfo.uid, msn, 3);
          if (res.data?.code !== 1) {
            if (options.showErrorToast !== false) {
              this.$message && this.$message.error(res.data?.msg || this.t('发送失败'));
            }
            return false;
          }
        } catch (e) {
          if (options.showErrorToast !== false) {
            this.$message && this.$message.error(this.t('发送失败'));
          }
          return false;
        }
      }
      this.messageList.push({
        id: (options.localIdPrefix || 'local_goods_') + Date.now(),
        uid: this.myUid,
        to_uid: this.kefuInfo.uid,
        msn,
        msn_type: 3,
        create_time: Math.floor(Date.now() / 1000),
      });
      this.$nextTick(() => this.scrollToBottom());
      return true;
    },
    async sendPendingGoods() {
      if (!this.pendingGoods) return false;
      const goods = { ...this.pendingGoods };
      const success = await this.sendGoodsCard(goods, {
        showErrorToast: true,
        localIdPrefix: 'local_goods_',
      });
      if (success) {
        this.pendingGoods = null;
      }
      return success;
    },
    async tryAutoReply(text) {
      const keyword = String(text || '').trim();
      if (!keyword) return false;

      const kefuUid = Number(this.kefuInfo.uid || 0);
      const isExplicitlyOffline = this.kefuInfo && this.kefuInfo.online === false;

      try {
        const { data } = await getAutoReply(keyword, kefuUid);
        const replyData = data && data.code === 1 ? data.data : null;
        if (replyData && replyData.reply_content) {
          const replyType = String(replyData.reply_type ?? replyData.msn_type ?? 1);
          const autoMsg = {
            id: replyData.id || ('auto_' + Date.now()),
            uid: replyData.uid || kefuUid,
            msn: replyData.msn || replyData.reply_content,
            msn_type: Number(replyData.msn_type) || (replyType === '2' || replyType === 'image' ? 2 : 1),
            create_time: Number(replyData.create_time || Math.floor(Date.now() / 1000)),
          };
          const existingIdx = autoMsg.id
            ? this.messageList.findIndex(msg => String(msg.id) === String(autoMsg.id))
            : -1;
          if (existingIdx !== -1) {
            this.$set(this.messageList, existingIdx, autoMsg);
          } else {
            this.messageList.push(autoMsg);
          }
          this.$nextTick(() => this.scrollToBottom());
          return true;
        }
      } catch (e) { /* ignore */ }

      // 仅在客服状态已明确为离线时，才回退到离线留言兜底消息
      if (!isExplicitlyOffline) return false;

      if (!this.kefuConfig) {
        try {
          await this.loadKefuConfig();
        } catch (e) { /* ignore */ }
      }

      const feedbackMsg = this.kefuConfig?.kefu_feedback || this.t('客服当前不在线，有问题请给我们留言，我们会尽快回复您！');
      const localMsg = {
        id: 'feedback_' + Date.now(),
        uid: kefuUid || 0,
        msn: feedbackMsg,
        msn_type: 1,
        create_time: Math.floor(Date.now() / 1000),
      };
      this.messageList.push(localMsg);
      this.$nextTick(() => this.scrollToBottom());

      if (kefuUid) {
        try {
          const res = await saveOfflineFeedback(kefuUid, feedbackMsg);
          const payload = res && res.data ? res.data : null;
          const serverMsg = payload && payload.code === 1 ? payload.data : null;
          if (serverMsg && serverMsg.id) {
            const localIdx = this.messageList.indexOf(localMsg);
            if (localIdx !== -1) {
              this.$set(this.messageList, localIdx, { ...localMsg, ...serverMsg });
            } else {
              const replaceIdx = this.findReplaceableMessageIndex(serverMsg);
              if (replaceIdx !== -1) {
                this.$set(this.messageList, replaceIdx, serverMsg);
              } else if (!this.messageList.some(msg => String(msg.id) === String(serverMsg.id))) {
                this.messageList.push(serverMsg);
              }
            }
          }
        } catch (e) { /* ignore */ }
      }

      return true;
    },
    showDesktopNotification(msg) {
      if (!this.notificationGranted || !('Notification' in window)) return;
      const title = this.kefuInfo.nickname || this.t('在线客服');
      let body = msg.msn || this.t('收到新消息');
      if (msg.msn_type === 2) body = this.t('[图片]');
      if (msg.msn_type === 4) body = this.t('[视频]');
      if (this.isGoodsMessage(msg)) {
        const card = this.parseCard(msg.msn);
        body = this.t('[商品] {name}', { name: card.name || '' });
      }
      const n = new Notification(title, { body, icon: this.kefuInfo.avatar || '' });
      n.onclick = () => { window.focus(); this.openFromExternal(); n.close(); };
      setTimeout(() => n.close(), 5000);
    },
    showProactiveHint(msg) {
      let body = msg.msn || this.t('收到新的客服消息');
      if (msg.msn_type === 2) body = this.t('[图片]');
      if (msg.msn_type === 4) body = this.t('[视频]');
      if (this.isGoodsMessage(msg)) {
        const card = this.parseCard(msg.msn);
        body = card.name ? this.t('商品：{name}', { name: card.name }) : this.t('[商品]');
      }
      this.proactiveHint = body.length > 24 ? `${body.slice(0, 24)}...` : body;
      if (this.proactiveHintTimer) clearTimeout(this.proactiveHintTimer);
      this.proactiveHintTimer = setTimeout(() => {
        this.proactiveHint = '';
        this.proactiveHintTimer = null;
      }, 8000);
    },
    startPollMessages() {
      if (this.pollTimer) return;
      this.pollTimer = setInterval(() => {
        this.pollNewMessages();
      }, 5000);
      this.pollNewMessages();
    },
    stopPollMessages() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    async pollNewMessages() {
      if (!this.kefuInfo.uid) return;
      // 每6次轮询(约30秒)刷新客服在线状态
      this.pollCount++;
      if (this.pollCount % 6 === 0) {
        try {
          const { data: kRes } = await getKefuInfo('pc');
          if (kRes.code === 1 && kRes.data) {
            this.kefuInfo = kRes.data;
            if (this.kefuInfo.avatar) this.kefuInfo.avatar = this.getImageUrl(this.kefuInfo.avatar);
          }
        } catch (e) { /* ignore */ }
      }
      try {
        const { data } = await getChatHistory(this.kefuInfo.uid, 1, 20);
        if (data.code === 1) {
          const list = data.data?.list || [];
          if (!list.length) return;
          // 用ID集合去重，包括本地消息和服务端消息
          const existingIds = new Set(this.messageList.map(m => String(m.id)));
          const newMsgs = list.filter(m => m.id && !existingIds.has(String(m.id)));
          // 替换本地临时消息（local/auto/feedback）为服务端真实消息
          newMsgs.forEach(serverMsg => {
            const localIdx = this.findReplaceableMessageIndex(serverMsg);
            if (localIdx !== -1) {
              this.$set(this.messageList, localIdx, serverMsg);
            }
          });
          const finalNew = newMsgs.filter(m =>
            !this.messageList.some(lm => String(lm.id) === String(m.id)) &&
            this.findReplaceableMessageIndex(m) === -1
          );
          if (finalNew.length > 0) {
            this.messageList.push(...finalNew);
            if (this.chatOpen) {
              this.$nextTick(() => this.scrollToBottom());
              markRead(this.kefuInfo.uid).catch(() => {});
            } else {
              this.unreadCount += finalNew.length;
              finalNew.forEach(msg => this.showDesktopNotification(msg));
              this.showProactiveHint(finalNew[finalNew.length - 1]);
            }
          }
        }
      } catch (e) {
        // silent
      }
    },
  },
};
</script>

<style scoped lang="scss">
.kefu-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.kefu-container.kefu-mobile-mode {
  align-items: stretch;
}

.kefu-trigger {
  position: relative;
  width: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  border-radius: 6px 6px 0 0;
  background: #00903b;
  color: #fff;
  cursor: pointer;
  transition: background 0.25s ease, transform 0.25s ease;

  &:hover,
  &.active {
    background: #007a32;
  }
}

.kefu-label {
  margin-top: 4px;
  font-size: 11px;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.kefu-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #ff4d4f;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  box-shadow: 0 6px 16px rgba(255, 77, 79, 0.35);
}

.kefu-proactive-tip {
  position: fixed;
  right: 92px;
  bottom: 84px;
  max-width: 280px;
  padding: 12px 16px;
  border: 1px solid rgba(0, 144, 59, 0.12);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.96);
  color: #24323d;
  font-size: 13px;
  line-height: 1.5;
  cursor: pointer;
  box-shadow: 0 20px 38px rgba(15, 23, 42, 0.14);
  backdrop-filter: blur(10px);
  z-index: 1000;
}

.kefu-slide-enter-active,
.kefu-slide-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.kefu-slide-enter,
.kefu-slide-leave-to {
  opacity: 0;
  transform: translateY(18px) scale(0.98);
}

.kefu-chat-window {
  position: fixed;
  right: 90px;
  bottom: 20px;
  width: 500px;
  height: 640px;
  min-width: 420px;
  min-height: 500px;
  max-width: 560px;
  max-height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 24px;
  background: #f6f7f9;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.18), 0 6px 18px rgba(15, 23, 42, 0.08);
  resize: both;
}

.kefu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: linear-gradient(180deg, #ffffff 0%, #fbfcfc 100%);
  flex-shrink: 0;
}

.kefu-header-info {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.kefu-avatar-wrap {
  position: relative;
  flex-shrink: 0;
}

.kefu-avatar {
  width: 46px;
  height: 46px;
  object-fit: cover;
  border-radius: 16px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
}

.kefu-online-dot {
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 12px;
  height: 12px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #c0c8d2;

  &.online {
    background: #14a44d;
    box-shadow: 0 0 0 4px rgba(20, 164, 77, 0.12);
  }
}

.kefu-header-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.kefu-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.kefu-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 700;
  color: #18222c;
  letter-spacing: 0.2px;
}

.kefu-identity-chip {
  flex-shrink: 0;
  padding: 3px 8px;
  border-radius: 999px;
  background: rgba(0, 144, 59, 0.08);
  color: #00903b;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
}

.kefu-status {
  font-size: 12px;
  color: #77818d;
  line-height: 1.4;

  &.online {
    color: #4b5a66;
  }
}

.kefu-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.kefu-feedback-menu {
  position: relative;
}

.kefu-feedback-trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 12px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 999px;
  background: #fff;
  color: #5f6c78;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: rgba(0, 144, 59, 0.2);
    color: #00903b;
    box-shadow: 0 8px 20px rgba(0, 144, 59, 0.08);
  }
}

.feedback-dot {
  position: absolute;
  top: 6px;
  right: 8px;
  width: 7px;
  height: 7px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #ff4d4f;
}

.kefu-feedback-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 168px;
  padding: 6px 0;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 18px 32px rgba(15, 23, 42, 0.14);
  z-index: 120;
}

.fb-drop-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  color: #253341;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease;

  &:hover {
    background: #f3f8f4;
    color: #00903b;
  }
}

.fb-drop-badge {
  margin-left: auto;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: #ff4d4f;
  color: #fff;
  font-size: 10px;
  line-height: 16px;
  text-align: center;
}

.fade-drop-enter-active,
.fade-drop-leave-active {
  transition: opacity 0.16s ease, transform 0.16s ease;
}

.fade-drop-enter-from,
.fade-drop-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.kefu-close {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #7b8792;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(15, 23, 42, 0.06);
    color: #1f2937;
  }
}

.kefu-messages {
  flex: 1;
  overflow-y: auto;
  padding: 18px 18px 12px;
  background:
    radial-gradient(circle at top right, rgba(0, 144, 59, 0.06), transparent 30%),
    linear-gradient(180deg, #f8f9fb 0%, #f4f6f8 100%);
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.55);
    border-radius: 999px;
  }
}

.load-more {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  cursor: pointer;

  span {
    padding: 6px 14px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.88);
    color: #74808d;
    font-size: 12px;
    line-height: 1;
    transition: all 0.2s ease;
  }

  &:hover span {
    color: #00903b;
    box-shadow: 0 8px 18px rgba(0, 144, 59, 0.08);
  }
}

.msg-item {
  margin-bottom: 14px;
  animation: msgSlideIn 0.24s ease-out;
}

@keyframes msgSlideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.msg-time-divider {
  display: flex;
  justify-content: center;
  margin: 12px 0 10px;

  span {
    padding: 4px 12px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.82);
    color: #8b97a3;
    font-size: 11px;
    line-height: 1;
    box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.04);
  }
}

.msg-system-tip {
  display: flex;
  justify-content: center;
}

.msg-system-tip-text {
  max-width: 84%;
  padding: 7px 14px;
  border: 1px solid #f6dfab;
  border-radius: 999px;
  background: #fff8e8;
  color: #a46a00;
  font-size: 12px;
  line-height: 1.45;
  text-align: center;
}

.msg-content-wrap {
  display: flex;
  align-items: flex-end;
  gap: 10px;
}

.msg-content-wrap-welcome {
  align-items: flex-start;
}

.msg-mine .msg-content-wrap {
  justify-content: flex-end;
}

.msg-avatar {
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 14px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
  flex-shrink: 0;
}

.msg-bubble-area {
  max-width: 78%;
  display: flex;
  flex-direction: column;
}

.msg-mine .msg-bubble-area {
  align-items: flex-end;
}

.msg-bubble {
  padding: 11px 14px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 18px;
  background: #fff;
  color: #253341;
  font-size: 14px;
  line-height: 1.6;
  word-break: break-word;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
}

.msg-other .msg-bubble {
  border-bottom-left-radius: 6px;
}

.msg-mine .msg-bubble {
  border-color: rgba(0, 144, 59, 0.12);
  background: linear-gradient(180deg, #f4fff8 0%, #eefaf3 100%);
  border-bottom-right-radius: 6px;
}

.msg-bubble-card,
.msg-bubble-media {
  padding: 0;
  overflow: hidden;
}

.msg-text {
  font-size: 14px;
  line-height: 1.65;
  white-space: pre-wrap;
}

.msg-send-failed {
  margin-top: 5px;
  color: #e02e24;
  font-size: 11px;
  cursor: pointer;

  em {
    font-style: normal;
    font-weight: 600;
    text-decoration: underline;
  }
}

.msg-read-status {
  margin-top: 5px;
  color: #96a0aa;
  font-size: 11px;
}

.welcome-bubble-area {
  max-width: 84%;
}

.welcome-card {
  padding: 14px;
  border: 1px solid rgba(0, 144, 59, 0.1);
  border-radius: 20px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fcf9 100%);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.07);
}

.welcome-card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.welcome-card-tag {
  padding: 4px 8px;
  border-radius: 999px;
  background: rgba(0, 144, 59, 0.1);
  color: #00903b;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

.welcome-card-caption {
  color: #81909d;
  font-size: 12px;
}

.welcome-card-text {
  margin-bottom: 12px;
  color: #24323d;
  font-size: 14px;
  line-height: 1.65;
}

.welcome-card-question {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
  padding: 10px 12px;
  border: 1px solid rgba(0, 144, 59, 0.12);
  border-radius: 14px;
  background: #fff;
  color: #21303b;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: rgba(0, 144, 59, 0.28);
    background: #f4fbf6;
    transform: translateX(2px);
  }
}

.welcome-card-question-text {
  flex: 1;
  font-size: 13px;
  line-height: 1.5;
}

.welcome-card-arrow {
  flex-shrink: 0;
  color: #00903b;
  font-size: 18px;
  line-height: 1;
}

.welcome-card-footer {
  margin-top: 12px;
  color: #97a3af;
  font-size: 11px;
  line-height: 1.5;
}

.msg-image {
  display: block;
  max-width: 220px;
  border-radius: 18px;
  cursor: pointer;
}

.msg-video {
  display: block;
  width: 240px;
  max-width: 100%;
  border-radius: 18px;
  background: #000;
}

.goods-card,
.order-card-bubble {
  width: 100%;
  min-width: 248px;
  max-width: 294px;
  background: #fff;
}

.goods-card {
  display: flex;
  gap: 12px;
  padding: 12px;
  cursor: pointer;
}

.goods-card-thumb-wrap {
  width: 88px;
  height: 88px;
  border-radius: 16px;
  overflow: hidden;
  flex-shrink: 0;
  background: #f4f6f8;
}

.goods-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.goods-card-info {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.goods-card-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #1f2933;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.5;
}

.goods-card-meta {
  margin-top: 8px;
  color: #8a97a4;
  font-size: 11px;
}

.goods-card-footer {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.goods-card-price {
  color: #e02e24;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
}

.goods-card-action {
  padding: 6px 10px;
  border-radius: 999px;
  background: #f4fbf6;
  color: #00903b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.order-card-bubble {
  padding: 12px;
  border-radius: 18px;
  cursor: pointer;
}

.order-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #edf1f3;
}

.order-card-label {
  color: #1f2933;
  font-size: 14px;
  font-weight: 700;
}

.order-card-status {
  color: #8b6b00;
  font-size: 12px;
  font-weight: 600;
}

.order-card-body {
  display: flex;
  gap: 12px;
  padding-top: 12px;
}

.order-card-img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 16px;
  background: #f4f6f8;
  flex-shrink: 0;
}

.order-card-info {
  min-width: 0;
  flex: 1;
}

.order-card-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #22313d;
  font-size: 13px;
  line-height: 1.5;
}

.order-card-price {
  margin-top: 8px;
  color: #e02e24;
  font-size: 18px;
  font-weight: 700;
}

.order-card-foot {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: #8b97a3;
  font-size: 11px;
}

.order-card-action {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.order-card-pay-btn {
  padding: 7px 12px;
  border-radius: 999px;
  background: #fdf1ef;
  color: #e02e24;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.kefu-typing {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px 0;
  color: #7e8a96;
  font-size: 12px;
  flex-shrink: 0;
}

.typing-dots {
  display: flex;
  gap: 4px;

  i {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #94a3b8;
    display: block;
    animation: typingDot 1.4s infinite ease-in-out;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
}

@keyframes typingDot {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.kefu-input-area {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 16px 16px;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #ffffff 100%);
  flex-shrink: 0;
}

.emoji-panel {
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: calc(100% + 10px);
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 18px 30px rgba(15, 23, 42, 0.12);
  z-index: 50;
  overflow: hidden;
}

.emoji-tabs {
  display: flex;
  gap: 6px;
  padding: 10px 12px;
  border-bottom: 1px solid #edf1f3;
  background: #fafbfc;
}

.emoji-tab {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  cursor: pointer;
  font-size: 18px;
  transition: all 0.2s ease;

  &:hover,
  &.active {
    background: rgba(0, 144, 59, 0.08);
  }
}

.emoji-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 4px;
  padding: 12px;
  max-height: 220px;
  overflow-y: auto;
}

.emoji-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 22px;
  transition: background 0.2s ease;

  &:hover {
    background: #f5f8f6;
  }
}

.kefu-pending-strip {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid rgba(0, 144, 59, 0.1);
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f7fbf8 100%);
}

.kefu-pending-image {
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 14px;
  background: #f2f4f7;
  flex-shrink: 0;
}

.kefu-pending-info {
  min-width: 0;
  flex: 1;
}

.kefu-pending-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1f2933;
  font-size: 13px;
  font-weight: 600;
}

.kefu-pending-subtitle {
  margin-top: 4px;
  color: #8693a0;
  font-size: 12px;
  line-height: 1.45;
}

.kefu-pending-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  flex-shrink: 0;
}

.kefu-pending-price {
  color: #e02e24;
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
}

.kefu-pending-buttons {
  display: flex;
  gap: 8px;
}

.kefu-pending-cancel,
.kefu-pending-send {
  min-width: 52px;
  height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.kefu-pending-cancel {
  border: 1px solid rgba(15, 23, 42, 0.09);
  background: #fff;
  color: #63707c;
}

.kefu-pending-send {
  border: none;
  background: #00903b;
  color: #fff;

  &:hover {
    background: #007a32;
  }
}

.kefu-input-shell {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
}

.kefu-input-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.kefu-text-input {
  flex: 1;
  height: 42px;
  padding: 0 14px;
  border: 1px solid #dde3e8;
  border-radius: 14px;
  background: #f8fafb;
  color: #22313d;
  font-size: 14px;
  outline: none;
  transition: all 0.2s ease;

  &:focus {
    border-color: rgba(0, 144, 59, 0.35);
    background: #fff;
    box-shadow: 0 0 0 4px rgba(0, 144, 59, 0.08);
  }

  &::placeholder {
    color: #9aa5b1;
  }
}

.kefu-send-btn {
  height: 42px;
  padding: 0 18px;
  border: none;
  border-radius: 14px;
  background: #cdd5dc;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;

  &:disabled {
    cursor: not-allowed;
  }

  &:not(:disabled) {
    background: #00903b;
    box-shadow: 0 10px 18px rgba(0, 144, 59, 0.22);
  }

  &:not(:disabled):hover {
    background: #007a32;
    transform: translateY(-1px);
  }
}

.kefu-input-tools {
  display: flex;
  align-items: center;
  gap: 8px;
}

.kefu-tool-btn {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #f4f7f6;
  color: #64717c;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #e9f6ee;
    color: #00903b;
  }
}

.emoji-btn {
  user-select: none;
}

.kefu-paste-hint {
  margin-left: 4px;
  color: #96a1ac;
  font-size: 11px;
  line-height: 1.4;
}

.feedback-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.42);
  backdrop-filter: blur(4px);
  z-index: 10001;
}

.feedback-modal {
  width: 460px;
  max-width: 92vw;
  max-height: 85vh;
  overflow-y: auto;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 24px 54px rgba(15, 23, 42, 0.22);
  animation: feedbackModalIn 0.24s ease;
}

@keyframes feedbackModalIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.feedback-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 1px solid #edf1f3;
  color: #18222c;
  font-size: 16px;
  font-weight: 700;
}

.feedback-back {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}

.feedback-close {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #7b8792;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(15, 23, 42, 0.05);
    color: #1f2937;
  }
}

.feedback-body {
  padding: 20px 22px;
}

.feedback-field {
  margin-bottom: 18px;

  &:last-child {
    margin-bottom: 0;
  }

  label {
    display: block;
    margin-bottom: 8px;
    color: #41505c;
    font-size: 13px;
    font-weight: 600;
  }

  em {
    color: #00903b;
    font-style: normal;
  }

  input,
  textarea {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #dde3e8;
    border-radius: 12px;
    background: #f8fafb;
    color: #24323d;
    font-size: 14px;
    outline: none;
    transition: all 0.2s ease;

    &:focus {
      border-color: rgba(0, 144, 59, 0.35);
      background: #fff;
      box-shadow: 0 0 0 4px rgba(0, 144, 59, 0.08);
    }

    &::placeholder {
      color: #9aa5b1;
    }
  }

  input {
    height: 42px;
    padding: 0 12px;
  }

  textarea {
    min-height: 96px;
    padding: 10px 12px;
    resize: vertical;
    font-family: inherit;
  }
}

.feedback-category-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.feedback-category-tag {
  padding: 7px 14px;
  border: 1px solid transparent;
  border-radius: 999px;
  background: #f3f5f7;
  color: #60707c;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    background: #eef5f0;
    color: #00903b;
  }

  &.active {
    border-color: rgba(0, 144, 59, 0.2);
    background: rgba(0, 144, 59, 0.08);
    color: #00903b;
    font-weight: 700;
  }
}

.feedback-char-count {
  margin-top: 4px;
  color: #9aa5b1;
  font-size: 12px;
  text-align: right;
}

.feedback-img-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.feedback-img-item {
  position: relative;
  width: 80px;
  height: 80px;
  overflow: hidden;
  border-radius: 12px;
  background: #f2f4f7;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.feedback-img-del {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(15, 23, 42, 0.58);
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.feedback-img-add {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px dashed #cfd8df;
  border-radius: 12px;
  background: #fbfcfc;
  color: #97a3af;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: rgba(0, 144, 59, 0.24);
    background: #f4fbf6;
    color: #00903b;
  }
}

.feedback-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 22px 20px;
  border-top: 1px solid #edf1f3;
}

.feedback-cancel-btn,
.feedback-submit-btn {
  height: 38px;
  padding: 0 18px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.feedback-cancel-btn {
  border: 1px solid #d9e0e6;
  background: #fff;
  color: #5e6b77;
}

.feedback-submit-btn {
  border: none;
  background: #00903b;
  color: #fff;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background: #007a32;
    box-shadow: 0 10px 18px rgba(0, 144, 59, 0.2);
  }
}

.my-feedback-modal {
  max-width: 540px;
  display: flex;
  flex-direction: column;
}

.my-feedback-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.my-feedback-loading,
.my-feedback-empty {
  padding: 48px 0;
  color: #8b97a3;
  font-size: 14px;
  text-align: center;
}

.my-feedback-card {
  margin-bottom: 10px;
  padding: 14px 16px;
  border: 1px solid #edf1f3;
  border-radius: 16px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: rgba(0, 144, 59, 0.22);
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
  }
}

.mf-card-top {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.mf-category {
  padding: 3px 8px;
  border-radius: 999px;
  background: #f3f5f7;
  color: #5d6b77;
  font-size: 12px;
}

.mf-status {
  font-size: 12px;
  font-weight: 700;

  &.mf-status-0 {
    color: #b7791f;
  }

  &.mf-status-2 {
    color: #2563eb;
  }

  &.mf-status-1 {
    color: #16a34a;
  }
}

.mf-unread-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #00903b;
}

.mf-content {
  color: #24323d;
  font-size: 14px;
  line-height: 1.6;
}

.mf-reply {
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 12px;
  background: #f7faf8;
  color: #5f6c78;
  font-size: 13px;
  line-height: 1.5;
}

.mf-reply-label {
  color: #00903b;
  font-weight: 700;
}

.mf-time {
  margin-top: 8px;
  color: #99a4af;
  font-size: 12px;
}

.my-feedback-load-more {
  padding: 12px;
  color: #00903b;
  font-size: 13px;
  text-align: center;
  cursor: pointer;
}

.feedback-detail-body {
  padding: 20px !important;
}

.fd-bubble {
  margin-bottom: 12px;
  padding: 14px 16px;
  border-radius: 16px;
}

.fd-bubble-user {
  border: 1px solid rgba(0, 144, 59, 0.1);
  background: #f8fcf9;
}

.fd-bubble-admin {
  border: 1px solid #dbe7ff;
  background: #f5f9ff;
}

.fd-bubble-category {
  display: inline-block;
  margin-bottom: 8px;
  padding: 3px 8px;
  border-radius: 999px;
  background: #00903b;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.fd-bubble-label {
  margin-bottom: 6px;
  color: #2563eb;
  font-size: 12px;
  font-weight: 700;
}

.fd-bubble-content {
  color: #253341;
  font-size: 14px;
  line-height: 1.65;
  white-space: pre-wrap;
}

.fd-bubble-images {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;

  img {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 10px;
    cursor: pointer;
    border: 1px solid #e5eaef;
  }
}

.fd-bubble-meta {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: #97a3af;
  font-size: 12px;
}

.fd-status-tag {
  margin-bottom: 12px;
  padding: 9px 12px;
  border-radius: 12px;
  background: #f4f6f8;
  color: #51606d;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
}

.fd-append-bar {
  display: flex;
  gap: 8px;
  margin-top: 8px;

  input {
    flex: 1;
    height: 40px;
    padding: 0 12px;
    border: 1px solid #d9e0e6;
    border-radius: 12px;
    outline: none;
    font-size: 14px;

    &:focus {
      border-color: rgba(0, 144, 59, 0.35);
    }
  }

  button {
    height: 40px;
    padding: 0 16px;
    border: none;
    border-radius: 12px;
    background: #00903b;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}

@media screen and (max-width: 750px) {
  .kefu-chat-window {
    right: 0;
    left: 0;
    bottom: 0;
    width: 100vw;
    height: 84vh;
    min-width: 0;
    min-height: 0;
    max-width: none;
    max-height: 84vh;
    border-radius: 24px 24px 0 0;
    resize: none;
  }

  .kefu-proactive-tip {
    display: none;
  }

  .kefu-header {
    padding: 16px;
  }

  .kefu-name-row {
    flex-wrap: wrap;
  }

  .kefu-header-actions {
    gap: 6px;
  }

  .kefu-feedback-trigger span {
    display: none;
  }

  .kefu-messages {
    padding: 14px 14px 10px;
  }

  .msg-bubble-area,
  .welcome-bubble-area {
    max-width: 84%;
  }

  .goods-card,
  .order-card-bubble {
    min-width: 0;
    max-width: 100%;
  }

  .goods-card {
    padding: 10px;
  }

  .kefu-pending-strip {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .kefu-pending-actions {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .kefu-input-area {
    padding: 10px 12px 14px;
  }

  .kefu-input-shell {
    padding: 10px;
  }

  .kefu-input-tools {
    flex-wrap: wrap;
  }

  .kefu-paste-hint {
    display: none;
  }

  .emoji-panel {
    left: 10px;
    right: 10px;
  }

  .feedback-modal,
  .my-feedback-modal {
    width: calc(100vw - 24px);
    max-width: none;
    max-height: 80vh;
  }

  .feedback-header {
    padding: 16px 18px;
  }

  .feedback-body,
  .my-feedback-body,
  .feedback-detail-body {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .feedback-footer {
    padding: 12px 16px 16px;
  }
}
</style>

